export default __webpack_public_path__ + "static/media/InitialImage.3e2912bb.svg";